import React, { useEffect, useState } from "react";
import _ from "lodash";
import { useAdminState } from "../contexts/AdminContext";
import * as API from "../api/request";
import Swal from "sweetalert2";
import Category from "../components/Category";
import Article from "../components/Article";
import Data from "../components/Data";
import { useOpenState } from "../contexts/OpenContext";

const Admin = () => {
  const { admin, setAdmin } = useAdminState();
  const { state } = useOpenState();

  const [list, setList] = useState([]);

  useEffect(() => {
    if (admin.article.list.length > 0) {
      API.getData()
        .then((res) => {
          var result = [];
          if (res.length > 0) {
            _.map(admin.article.list, (el) => {
              var department_name = _.map(el?.departments, (d, index) =>
                index === 0 ? d?.department_name : " " + d?.department_name
              );
              var fd = _.filter(res, (a) => a?.article_id === el?.id);
              if (fd?.length > 0) {
                _.map(fd, (i) => {
                  return result.push({
                    ...i,
                    article_name: el?.article_name,
                    department_name: _.toString(department_name),
                  });
                });
              }
            });
          }
          setAdmin({
            type: "DATA_CHANGE_STATE",
            data: {
              list: _.orderBy(result, ["department_name"]),
            },
          });
        })
        .catch(() => {
          Swal.fire("Анхаар", "Жагсаалт татаж чадсангүй!", "warning");
        });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [admin.data.refresh, admin.article.list]);

  const trash = (id) => {
    Swal.fire({
      title: "Та устгахдаа итгэлтэй байна уу?",
      text: "Сэргэх боломжгүйг анхаарна уу!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Тийм",
      cancelButtonText: "Үгүй",
    }).then((result) => {
      if (result.isConfirmed) {
        API.deleteData(id)
          .then(() => {
            setAdmin({
              type: "DATA_CHANGE_STATE",
              data: { refresh: admin.data.refresh + 1, modal: false },
            });
            Swal.fire("Амжилттай", "Амжилттай устгалаа.", "success");
          })
          .catch(() => {
            Swal.fire(
              "Анхаар",
              "Устгаж чадсангүй дахин оролдоно уу!",
              "warning"
            );
          });
      }
    });
  };

  useEffect(() => {
    if (admin.data.list.length > 0) {
      var result = admin?.data?.list;
      if (admin.data.s_department_name !== "") {
        result = result.filter((el) =>
          el?.department_name
            ?.toString()
            ?.toLowerCase()
            ?.includes(
              admin?.data?.s_department_name?.toString()?.toLowerCase()
            )
        );
      }
      if (admin.data.s_data_name !== "") {
        result = result.filter((el) =>
          el?.data_name
            ?.toString()
            ?.toLowerCase()
            ?.includes(admin?.data?.s_data_name?.toString()?.toLowerCase())
        );
      }
      if (admin.data.s_article_name !== "") {
        result = result.filter((el) =>
          el?.article_name
            ?.toString()
            ?.toLowerCase()
            ?.includes(admin?.data?.s_article_name?.toString()?.toLowerCase())
        );
      }
      setList(result);
    }
  }, [
    admin.data.list,
    admin.data.s_article_name,
    admin.data.s_data_name,
    admin.data.s_department_name,
  ]);

  return (
    <>
      <div className="flex w-full items-center justify-start gap-5 border-b p-4">
        {state?.userGroupList?.includes(362) && (
          <>
            <button
              className="py-1 px-2 flex items-center justify-center font-semibold text-[#A3C050] border-2 border-[#A3C050] rounded-md hover:bg-[#A3C050] hover:text-white focus:outline-none duration-300"
              onClick={() => setAdmin({ type: "CATEGORY_MODAL", data: true })}
            >
              Бүлэг
              <i className="fa fa-plus ml-2 text-xs" />
            </button>
            <button
              className="py-1 px-2 flex items-center justify-center font-semibold text-[#A3C050] border-2 border-[#A3C050] rounded-md hover:bg-[#A3C050] hover:text-white focus:outline-none duration-300"
              onClick={() => setAdmin({ type: "ARTICLE_MODAL", data: true })}
            >
              Гарчиг
              <i className="fa fa-plus ml-2 text-xs" />
            </button>
          </>
        )}

        <button
          className="py-1 px-2 flex items-center justify-center font-semibold text-[#A3C050] border-2 border-[#A3C050] rounded-md hover:bg-[#A3C050] hover:text-white focus:outline-none duration-300"
          onClick={() =>
            setAdmin({
              type: "DATA_CHANGE_STATE",
              data: {
                id: 0,
                modal: true,
                files: [],
                article_id: undefined,
                data_name: "",
                url: "",
              },
            })
          }
        >
          Өгөгдөл
          <i className="fa fa-plus ml-2 text-xs" />
        </button>
      </div>
      <div className="max-h-[calc(100vh-120px)] scrollbar">
        <table className="min-w-full mt-3">
          <thead className="border-b">
            <tr className="bg-gray-100">
              <th
                scope="col"
                className="text-sm font-medium text-gray-900 px-2 py-2 text-center w-[50px] border-r border-l"
              >
                №
              </th>
              <th
                scope="col"
                className="text-sm font-medium text-gray-900 px-2 py-2 text-center w-[50px] border-r border-l"
              >
                <div className="flex flex-col">
                  <div className="mr-2">Бүтцийн нэгж</div>
                  <input
                    type="search"
                    name="q"
                    className="py-1 text-sm text-gray-900 bg-white rounded px-2 focus:outline-none focus:shadow-outline border min-w-80"
                    placeholder="Хайх ..."
                    autoComplete="off"
                    onChange={(e) => {
                      setAdmin({
                        type: "DATA_CHANGE_STATE",
                        data: {
                          s_department_name: e.target.value,
                        },
                      });
                    }}
                    value={admin.data.s_department_name}
                  />
                </div>
              </th>
              <th
                scope="col"
                className="text-sm font-medium text-gray-900 px-2 py-2 text-left border-r"
              >
                <div className="flex flex-col">
                  <div className="mr-2">Гарчиг</div>
                  <input
                    type="search"
                    name="q"
                    className="py-1 text-sm text-gray-900 bg-white rounded px-2 focus:outline-none focus:shadow-outline border min-w-80"
                    placeholder="Хайх ..."
                    autoComplete="off"
                    onChange={(e) => {
                      setAdmin({
                        type: "DATA_CHANGE_STATE",
                        data: {
                          s_article_name: e.target.value,
                        },
                      });
                    }}
                    value={admin.data.s_article_name}
                  />
                </div>
              </th>
              <th
                scope="col"
                className="text-sm font-medium text-gray-900 px-2 py-2 text-left border-r"
              >
                <div className="flex flex-col">
                  <div className="mr-2">Нэр</div>
                  <input
                    type="search"
                    name="q"
                    className="py-1 text-sm text-gray-900 bg-white rounded px-2 focus:outline-none focus:shadow-outline border min-w-80"
                    placeholder="Хайх ..."
                    autoComplete="off"
                    onChange={(e) => {
                      setAdmin({
                        type: "DATA_CHANGE_STATE",
                        data: {
                          s_data_name: e.target.value,
                        },
                      });
                    }}
                    value={admin.data.s_data_name}
                  />
                </div>
              </th>

              <th
                scope="col"
                className="text-sm font-medium text-gray-900 px-2 py-2 text-left border-r"
              >
                Url зам
              </th>
              <th
                scope="col"
                className="text-sm font-medium text-gray-900 px-2 py-2 text-left border-r"
              >
                Файлууд
              </th>
              <th
                scope="col"
                className="text-sm font-medium text-gray-900 px-2 py-2 text-center w-[60px]"
              >
                #
              </th>
            </tr>
          </thead>
          <tbody>
            {list?.length > 0 ? (
              _.map(list, (el, index) => {
                return (
                  <tr className="border-b" key={index}>
                    <td className="px-2 py-2 whitespace-nowrap text-sm font-medium text-gray-900 text-center w-[50px] border-r border-l">
                      {index + 1}
                    </td>
                    <td className="text-sm text-gray-900 font-light px-2 py-2 border-r">
                      {el?.department_name}
                    </td>
                    <td className="text-sm text-gray-900 font-light px-2 py-2 border-r">
                      {el?.article_name}
                    </td>
                    <td className="text-sm text-gray-900 font-light px-2 py-2 border-r">
                      {el?.data_name}
                    </td>

                    <td className="text-sm text-gray-900 font-light px-2 py-2 border-r">
                      {el?.url}
                    </td>
                    <td className="text-sm text-gray-900 font-light px-2 py-2 border-r">
                      {_.map(el?.attachments, (item2, index2) => {
                        return <div key={index2}>{item2?.attachment_name}</div>;
                      })}
                    </td>
                    <td className="text-sm text-gray-900 font-light px-2 py-2 w-[60px] text-center border-r">
                      {(el?.created_user === state?.tn ||
                        state?.userGroupList?.includes(362)) && (
                        <>
                          <i
                            className="fa fa-edit text-blue-700 cursor-pointer mr-2"
                            onClick={() => {
                              setAdmin({
                                type: "DATA_CHANGE_STATE",
                                data: {
                                  id: el?.id,
                                  files: el?.attachments,
                                  article_id: el?.article_id,
                                  data_name: el?.data_name,
                                  url: el?.url,
                                  modal: true,
                                },
                              });
                            }}
                          />
                          <i
                            className="fa fa-trash text-red-700 cursor-pointer"
                            onClick={() => {
                              trash(el?.id);
                            }}
                          />
                        </>
                      )}
                    </td>
                  </tr>
                );
              })
            ) : (
              <tr className="border-b">
                <td
                  className="px-2 py-2 whitespace-nowrap text-sm font-medium text-gray-900 text-center"
                  colSpan={5}
                >
                  Хоосон байна
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>

      <Category />
      <Article />
      <Data />
    </>
  );
};

export default React.memo(Admin);
